/**
 * IONLOOP Assistant — shared knowledge category definitions.
 *
 * Single source of truth for the assistant knowledge categories, used by both
 * the UI navigation and the /topics slash command. Keys align 1:1 with the
 * categories in the generated knowledge index.
 */

module.exports = {
    CATEGORIES: [
        { key: 'getting-started', label: 'Getting started' },
        { key: 'trading-markets', label: 'Trading & Markets' },
        { key: 'ionloop-id', label: 'IONLOOP ID' },
        { key: 'planning-productivity', label: 'Planning & Productivity' },
        { key: 'account-security', label: 'Account & Security' },
        { key: 'wallet-payments', label: 'Wallet & Payments' },
        { key: 'automation', label: 'Automation' },
        { key: 'business-operations', label: 'Business Operations' },
        { key: 'help-policies', label: 'Help & Policies' }
    ]
};
